export default {
  pageTitle: 'Campaign performance',
  emailEngagement: {
    title: 'Email engagement overview',
  },
  emailEngagementByCampaignType: {
    title: 'Email engagement by campaign type',
  },
}
